module.exports = __webpack_public_path__ + "media/images/icons/circled-checkmark-c6ab9d277cdfd267c0fb76dd4ae57c7f.svg";